import dom from "../../../dist/jsx-render/dom";
import { ICustomerServive } from "../../Frame/CustomerService/ICustomerService";
import { TextComponent } from "../../Components/TextComponent";
import { CheckboxCompoment } from "../../Components/CheckboxComponent";
import { DynPopup } from "../../Components/DynPopup";
import { MeasureEditFactory } from "../../Pages/Measure/MeasureEditFactory";
import { PopupCloseType } from "../../Controls/PagePopup";
import { app } from "../../Frame/App";

export class BmwFFCustomerService implements ICustomerServive {



    public onNewMeasureMenuItem?(templateId: number) {
        if (templateId == 1) {
            let radio1: HTMLInputElement = <input className="form-check-input" type="radio" name="bmw-schema" id="bmw-schema-1" value="0" checked />;
            let radio2: HTMLInputElement = <input className="form-check-input" type="radio" name="bmw-schema" id="bmw-schema-2" value="1" />;
            let radio3: HTMLInputElement = <input className="form-check-input" type="radio" name="bmw-schema" id="bmw-schema-3" value="2" />;
            let radio4: HTMLInputElement = <input className="form-check-input" type="radio" name="bmw-schema" id="bmw-schema-4" value="3" />;
            let radio5: HTMLInputElement = <input className="form-check-input" type="radio" name="bmw-schema" id="bmw-schema-5" value="4" />;
            let radio6: HTMLInputElement = <input className="form-check-input" type="radio" name="bmw-schema" id="bmw-schema-6" value="5" />;
            let radio7: HTMLInputElement = <input className="form-check-input" type="radio" name="bmw-schema" id="bmw-schema-7" value="6" />;
            document.body.appendChild(
                <DynPopup size="small"
                    showCancelButton={true}
                    showSaveButton={true}
                    title="Neues Förderprojekt"
                    onSave={(): boolean => {
                        let schema = 0;
                        if (radio2.checked) {
                            schema = 1;
                        }
                        else if (radio3.checked) {
                            schema = 2;
                        }
                        else if (radio4.checked) {
                            schema = 3;
                        }
                        else if (radio5.checked) {
                            schema = 4;
                        }
                        else if (radio6.checked) {
                            schema = 5;
                        }
                        else if (radio7.checked) {
                            schema = 6;
                        }

                        MeasureEditFactory.showMeasure({
                            measureId: 0,
                            templateId: templateId,
                            parentId: 0,
                            parentGuid: "null",
                            fullScreen: true,
                            additionalAction: `schema:${schema}`,
                            onClose: ((reason: PopupCloseType, id: number) => {
                                app.dispatchOnNewMeasureCreated(reason, id);
                            })
                        });

                        return true;
                    }}>
                    <h6>Bitte wählen Sie das Abrechnungsschema: </h6>
                    <div className="ml-2 mt-2">
                        <div className="form-check pt-1">
                            {radio1}
                            <label className="form-check-label" for="bmw-schema-1">
                                Abrechnungsschema Bayern
                            </label>
                        </div>
                        <div className="form-check pt-1">
                            {radio2}
                            <label className="form-check-label" for="bmw-schema-2">
                                Abrechnungsschema Bund
                            </label>
                        </div>
                        <div className="form-check pt-1">
                            {radio3}
                            <label className="form-check-label" for="bmw-schema-3">
                                Abrechnungsschema H 2020(EU)
                            </label>
                        </div>
                        <div className="form-check pt-1">
                            {radio4}
                            <label className="form-check-label" for="bmw-schema-4">
                                EU Flexibel
                            </label>
                        </div>
                        <div className="form-check pt-1">
                            {radio5}
                            <label className="form-check-label" for="bmw-schema-5">
                                Flexibles Abrechnungsschema
                            </label>
                        </div>
                        <div className="form-check pt-1">
                            {radio6}
                            <label className="form-check-label" for="bmw-schema-6">
                                Abrechnungsschema Horizon Europe
                            </label>
                        </div>
                        <div className="form-check pt-1">
                            {radio7}
                            <label className="form-check-label" for="bmw-schema-7">
                                Horizon Europe Flexibel
                            </label>
                        </div>
                    </div>
                </DynPopup>
            );
        }
        else {
            MeasureEditFactory.showMeasure({
                measureId: 0,
                templateId: templateId,
                parentId: 0,
                parentGuid: "null",
                fullScreen: true,
                onClose: ((reason: PopupCloseType, id: number) => {
                    app.dispatchOnNewMeasureCreated(reason, id);
                })
            });
        }

    }

    tutorialPopupAdditionalControls = (model: any) => {

        return (
            <div className="additional-controls">

                <TextComponent model={model}
                    field="groupName"
                    name={Resources.Common.videoGroupName}
                />

                <CheckboxCompoment model={model}
                    field="showInNew"
                    label={Resources.Common.videoShowInNew}
                    createFormGroup={true}
                />

                <CheckboxCompoment model={model}
                    field="showInHelpPage"
                    label={Resources.Common.videoShowInHelpPage}
                    createFormGroup={true}
                />
            </div>
        );
    }

    getDocumentFieldCustomColumns = () => "download;annotation;comment;fileName;date;delete";
    getDocumentListCustomColumns = () => "download;blockName;annotation;comment;fileName;date";
}
